import { render, staticRenderFns } from "./AdminViewUsers.vue?vue&type=template&id=56f3d0cb&scoped=true&"
import script from "./AdminViewUsers.vue?vue&type=script&lang=js&"
export * from "./AdminViewUsers.vue?vue&type=script&lang=js&"
import style0 from "./AdminViewUsers.vue?vue&type=style&index=0&id=56f3d0cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f3d0cb",
  null
  
)

export default component.exports